export default __webpack_public_path__ + "static/media/kitten4XS.7f080724.webp";